/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityTriggerResponse
 */
export interface MonitEntityTriggerResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTriggerResponse
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTriggerResponse
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityTriggerResponse
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityTriggerResponse
     */
    privileged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityTriggerResponse
     */
    nocache?: boolean;
}

/**
 * Check if a given object implements the MonitEntityTriggerResponse interface.
 */
export function instanceOfMonitEntityTriggerResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityTriggerResponseFromJSON(json: any): MonitEntityTriggerResponse {
    return MonitEntityTriggerResponseFromJSONTyped(json, false);
}

export function MonitEntityTriggerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityTriggerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'privileged': !exists(json, 'privileged') ? undefined : json['privileged'],
        'nocache': !exists(json, 'nocache') ? undefined : json['nocache'],
    };
}

export function MonitEntityTriggerResponseToJSON(value?: MonitEntityTriggerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_domain': value.entity_domain,
        'type': value.type,
        'privileged': value.privileged,
        'nocache': value.nocache,
    };
}

